import {Stars} from "parts";
import {Trans, useTranslation} from "react-i18next";

export function Stores({usersOnly = false}) {
  const {t} = useTranslation('common', {keyPrefix: 'paywall.info.stores'})

  return (
    <div className={'block items'} style={{padding: 20}}>
      <div dir={'ltr'} className={'row gap-2 center'}>
        <img src={'/static/img/paywall/wreath-left.png'} loading={'lazy'} alt={''} width={44} height={68}/>
        <div className={'text-center'}>
          <h2 style={{marginBottom: 4}}>{t('header')}</h2>
          <p className={'small pre-line'}>{t('desc')}</p>
        </div>
        <img src={'/static/img/paywall/wreath-right.png'} loading={'lazy'} alt={''} width={44} height={68}/>
      </div>

      {
        !usersOnly &&
        <div className={'block w-100 items'}>
          <div className={'row text-center'} style={{justifyContent: 'space-around', alignItems: 'flex-end'}}>
            <div>
              <Stars className={'mb-1'} size={16}/>
              <Trans i18nKey={'rating'} t={t}>
                <em className={'h3 marked'}>4,6</em> <small className={'notice'}>out of 5</small>
              </Trans>
            </div>
            <a rel="noreferrer" href={process.env.REACT_APP_IOS_LINK} target={'_blank'}>
              <img src={'/static/img/paywall/apple-logo.svg'} loading={'lazy'} alt={''} width={28} height={28}
                   className={'d-block mx-auto mb-1'}/>
              <small className={'notice'}>{t('appStore')}</small>
            </a>
            <a rel="noreferrer" href={process.env.REACT_APP_GOOGLE_LINK} target={'_blank'}>
              <img src={'/static/img/paywall/google-play-logo.svg'} loading={'lazy'} alt={''} width={28} height={28}
                   className={'d-block mx-auto mb-1'}/>
              <small className={'notice'}>{t('googlePlay')}</small>
            </a>
          </div>

          <div className={'row gap-2 small-sm'}>
            <div className={'panel row gap-2 center'}>
              <Trans i18nKey={'ratings'} t={t}>
                <strong>25K</strong><em className={'notice'}>5-star ratings</em>
              </Trans>
            </div>
            <div className={'panel row gap-2 center'}>
              <Trans i18nKey={'downloads'} t={t}>
                <strong>2M</strong><em className={'notice'}>downloads</em>
              </Trans>
            </div>
          </div>
        </div>
      }
    </div>
  )
}